<template>
  <div id="the-collection">
    <b-container class="the-collection-container">
      <Header />
      <div class="cards">
        <ProductCard
          :productCardId="1"
          class="collection-card"
          :productData="{
            title: `PULLOVER HOODIE`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/deguzman/sweatshirt-black-01.jpg'),
              require('@/assets/images/products/deguzman/sweatshirt-black-02.jpg'),
              require('@/assets/images/products/deguzman/sweatshirt-white-01.jpg'),
              require('@/assets/images/products/deguzman/sweatshirt-white-02.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/deguzman/sweatshirt-black-01.jpg'),
              require('@/assets/images/products/deguzman/sweatshirt-black-02.jpg'),
              require('@/assets/images/products/deguzman/sweatshirt-white-01.jpg'),
              require('@/assets/images/products/deguzman/sweatshirt-white-02.jpg'),
            ],
            productSaleInfo: {
              productAvailable: true,
              textDate: 'BUY NOW',
            },
          }"
        >
          <h5 slot="product-title">
            PULLOVER<br />
            HOODIE
          </h5>
          <div slot="description">
            <p>
              This item features Louis De Guzman's artistic take on the club's
              iconic "C" headwear logo.
            </p>
          </div>
        </ProductCard>
        <ProductCard
          :productCardId="2"
          class="collection-card"
          :productData="{
            title: `SHORT-SLEEVE POCKET T-SHIRT`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/deguzman/tee-black-01.jpg'),
              require('@/assets/images/products/deguzman/tee-black-02.jpg'),
              require('@/assets/images/products/deguzman/tee-white-01.jpg'),
              require('@/assets/images/products/deguzman/tee-white-02.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/deguzman/tee-black-01.jpg'),
              require('@/assets/images/products/deguzman/tee-black-02.jpg'),
              require('@/assets/images/products/deguzman/tee-white-01.jpg'),
              require('@/assets/images/products/deguzman/tee-white-02.jpg'),
            ],
            productSaleInfo: {
              productAvailable: true,
              textDate: 'BUY NOW',
            },
          }"
        >
          <h5 slot="product-title">
            SHORT-SLEEVE<br />
            POCKET T-SHIRT
          </h5>
          <div slot="description">
            <p>
              This item features Louis De Guzman’s artistic take on the club’s
              iconic “C” headwear logo.
            </p>
          </div>
        </ProductCard>
        <ProductCard
          :productCardId="3"
          class="collection-card"
          :productData="{
            title: `MINIATURE REPLICA SCULPTURE`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/deguzman/sculpture-01.jpg'),
              require('@/assets/images/products/deguzman/sculpture-02.jpg'),
              require('@/assets/images/products/deguzman/sculpture-03.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/deguzman/sculpture-01.jpg'),
              require('@/assets/images/products/deguzman/sculpture-02.jpg'),
              require('@/assets/images/products/deguzman/sculpture-03.jpg'),
            ],
            productSaleInfo: {
              productAvailable: true,
              textDate: 'BUY NOW',
            },
          }"
        >
          <h5 slot="product-title">MINIATURE REPLICA SCULPTURE</h5>
          <div slot="description">
            <p>
              “COHERE” is designed in the shape of the Cubs’ “Angry Bear” logo
              and offers De Guzman’s creative interpretation of the iconic
              symbol with an emphasis on community and connection.
            </p>
            <p>Hand-painted resin sculpture</p>
            <p>7.5" W x 5" D x 8" H</p>
            <p>Individually signed and dated by Louis De Guzman</p>
          </div>
        </ProductCard>
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/sections/deguzman/Header";
import ProductCard from "@/components/global/ProductCard";
import moment from "moment";

import { mapState } from "vuex";
export default {
  name: "TheCollection",
  data() {
    return {
      moment,
      productAvailable: false,
    };
  },
  components: {
    Header,
    ProductCard,
  },
  computed: {
    ...mapState(["global"]),
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#the-collection {
  padding-bottom: 100px;
  @media (max-width: $lg) {
    padding-bottom: 50px;
  }
  @media (max-width: $md) {
    padding-bottom: 0px;
  }
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-collection-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    @media (max-width: $lg) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .cards {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 50px;
    @media (max-width: $lg) {
      flex-direction: column;
      align-items: center;
    }
  }
  .collection-card {
    width: 318px;
    max-width: 32.2%;
    @media (max-width: $lg) {
      margin-bottom: 50px;
      max-width: 100%;
    }
  }

  p,
  span {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: start;
    line-height: 23px;
    @media (max-width: $lg) {
      text-align: center;
    }
  }
}
</style>
